// eslint-disable-next-line import/prefer-default-export
export const THEMES = {
  WHITE: 'white',
  BLACK: 'black',
};
